export default class Layout {
  constructor (data = {}) {
    Object.keys(data).map(key => {
      this[key] = data[key];
    });
  }
  static fromJson (json) {
    return new Layout(json);
  }
}
